<script setup lang="ts">
import FireOutbreakCantRelateReaction from './FireOutbreakCantRelateReaction.vue'
import FireOutbreakNotOccurredReaction from './FireOutbreakNotOccurredReaction.vue'
import FireOutbreakOccurredReaction from './FireOutbreakOccurredReaction.vue'
import FireOutbreakNotReacted from './FireOutbreakNotReacted.vue'
import { computed } from 'vue'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'

const { reaction, danger = false } = defineProps<{
	reaction?: FireOutbreakReactionEnum
	danger?: boolean
}>()

const _reaction = computed(() => {
	switch (reaction) {
		case FireOutbreakReactionEnum.POSITIVE:
			return FireOutbreakOccurredReaction
		case FireOutbreakReactionEnum.NEGATIVE:
			return FireOutbreakNotOccurredReaction
		case FireOutbreakReactionEnum.IMPOSSIBLE:
			return FireOutbreakCantRelateReaction
		default:
			return FireOutbreakNotReacted
	}
})
</script>

<template>
	<component
		:is="_reaction"
		:danger="danger"
	/>
</template>
